import { Component } from '@angular/core';
import {AgreementService} from './resources/agreement/agreement.service';
import {Router} from '@angular/router';

@Component({
  selector:    'app-root',
  templateUrl: './app.component.html',
  styleUrls:   [ './app.component.sass' ]
})
export class AppComponent {
  title = 'app';

  constructor(private agreement: AgreementService,
              private router: Router
  ) {

  }

  ngOnInit() {

  }
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/app.component.ts